import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  return (
    <footer className="bg-[#063846] p-2 lg:px-28 font-inter">
      <div className='px-1'>
        <div className='flex justify-center py-2'>
          <img src='logo.webp' alt='' className='h-24 md:h-32 lg:h-36' />
        </div>
        <div className='flex flex-col lg:flex-row gap-2 text-white font-inter p-2'>
          <div className='flex flex-col'>
            <span className='font-bold md:text-xl lg:text-2xl'>Siap Hafal Al-Quran?</span>
            <span className='text-gray-400 md:text-lg lg:text-xl'>Rumah Tahfidz An-Nuur Menanti Anda, mari Menghafal Al-Quran Bersama Kami - Bersama menuju hafalan yang berkah.</span>
          </div>
          <div className='flex flex-col my-4 '>
            <p className='font-bold md:text-xl lg:text-2xl'>Informasi Kontak</p>
            <p className='text-gray-400 md:text-lg lg:text-xl'><FontAwesomeIcon icon={faPhone} className='mr-2'/>(+62) 812-3348-7147</p>
            <p className='text-gray-400 md:text-lg lg:text-xl'><FontAwesomeIcon icon={faLocationDot} className='mr-2'/><span></span>Jl. Tanjakan Sa'ar, RT.004/RW.004, Jatiluhur, Kec. Jatiasih, Kota Bks, Jawa Barat 17425</p>
          </div>
        </div>
      </div>
      <hr className='mb-4'></hr>
      <div className="container mx-auto text-center text-white">
        <p className='md:text-lg'>&copy; 2024 Rumah Tahfidz An-Nuur. <a href='/Dev'>All rights reserved.</a></p>
      </div>
    </footer>
  );
};

export default Footer;
